import Vue from "vue";
import Router from "vue-router";
import Temp from "./Temp";
import Index from "../src/view/Index";
import ChildPageTemp from "../src/view/ChildPageTemp";
import ResultTemp from "../src/view/ResultTemp";
import Entry from "../src/view/Entry/Entry";
import Verification from "../src/view/Verification/Verification";
import Personal from "../src/view/Verification/Personal";
import Company from "../src/view/Verification/Company";
import OnePass from "../src/view/Verification/Personal/OnePass";
import PhoneNum from "../src/view/Verification/Personal/PhoneNum";
import DataRegistration from "../src/view/DataRegistration/DataRegistration";
import FormData from "../src/view/DataRegistration/FormData/FormData";
import Upload from "../src/view/DataRegistration/Upload/Upload";
import Check from "../src/view/DataRegistration/Check/Check";
import Success from "../src/view/Success/Success";
import Taxi from "../src/view/DataRegistration/FormData/Taxi/Taxi";
import PaymentResult from "../src/view/DataRegistration/General/PaymentResult";
import PaymentRecord from "../src/view/DataRegistration/FormData/Taxi/PaymentRecord";
import Way from "../src/view/DataRegistration/FormData/Taxi/Way";
import Terms from "./view/Page/Terms";

import Search from "../src/view/Search/Search";
import SearchPersonal from "../src/view/Search/Personal";
import SearchStatus from "../src/view/Search/Status";
import AfterFiles from "../src/view/Search/AfterFiles/AfterFiles";

import Account from "../src/view/Account/Account";
import Account_app from "../src/view/Account/Account_app";
import bus_app from "../src/view/Account/Account_app";
import taxi_app from "../src/view/Account/Account_app";
import Face from "../src/view/Account/Face";

import Mpay from "../src/view/DataRegistration/FormData/Taxi/Mpay";

import International from "./view/DataRegistration/FormData/International/International";
import InternationalRecord from "./view/DataRegistration/FormData/International/InternationalRecord";
import Driving from "./view/Verification/Driving/Driving";
import DrivingSearch from "./view/Verification/Driving/DrivingSearch";
import DrivingPhoneNum from "./view/Verification/Driving/DrivingPhoneNum";

import SchoolVerification from "./view/Verification/School/School";
import HeadmasterAndCoachVerification from "./view/Verification/School/HeadmasterAndCoach";
import School from "./view/DataRegistration/FormData/School/School";
import HeadmasterAndCoach from "./view/DataRegistration/FormData/School/HeadmasterAndCoach";
import SchoolRecord from "./view/DataRegistration/FormData/School/Record";
import HmAndCoAccount from "./view/Verification/School/PersonalAccount";

import BookingVerification from "./view/Verification/Booking/Booking";
import Booking from "./view/Booking/BookingInfo";

import HzmbMoRenewCheck from "./view/DataRegistration/FormData/hzmbMoRenew/Check";
import HzmbMoRenewPayment from "./view/DataRegistration/FormData/hzmbMoRenew/Payment";
import HzmbMoPaymentResult from "./view/DataRegistration/FormData/hzmbMoRenew/PaymentResult";
import HzmbGFirstSuccess from "./view/DataRegistration/FormData/HzmbGFirst/Success";

import EntryHzmbTruck from "./view/Entry/EntryHzmbTruck";
import HzmbGFirstVerification from "./view/Verification/HzmbG/HzmbGFirst";
import HzmbGFirst from "./view/DataRegistration/FormData/HzmbGFirst/Index";
import HzmbGFirstApplication from "./view/DataRegistration/FormData/HzmbGFirst/Application";
import HzmbGFirstUpload from "./view/DataRegistration/FormData/HzmbGFirst/Upload";
import HzmbGFirstCheck from "./view/DataRegistration/FormData/HzmbGFirst/Check";
import HzmbGCancelVerification from "./view/Verification/HzmbG/HzmbGCancel";
import HzmbGCancelApplication from "./view/DataRegistration/FormData/HzmbGCancel/Application";
import HzmbGCancelSuccess from "./view/DataRegistration/FormData/HzmbGCancel/Success";

import HzmbHAccount from "./view/Verification/HzmbH/Account";
import HzmbHFirst from "./view/DataRegistration/FormData/HzmbHFirst/Index";
import HzmbHFirstApplication from "./view/DataRegistration/FormData/HzmbHFirst/Application";
import HzmbHFirstUpload from "./view/DataRegistration/FormData/HzmbHFirst/Upload";
import HzmbHFirstCheck from "./view/DataRegistration/FormData/HzmbHFirst/Check";
import HzmbHFirstSuccess from "./view/DataRegistration/FormData/HzmbHFirst/Success";
import HzmbHCancelApplication from "./view/DataRegistration/FormData/HzmbHCancel/Application";

Vue.use(Router);

export const DataRegistrationRoutes = [
  {
    path: "/formData",
    name: "FormData",
    meta: {
      name: "message.router.formData",
      type: "HZMB",
      showSteps: true,
    },
    component: FormData,
  },
  {
    path: "/upload",
    name: "Upload",
    meta: {
      name: "message.router.upload",
      type: "HZMB",
      showSteps: true,
    },
    component: Upload,
  },
  {
    path: "/check",
    name: "Check",
    meta: {
      name: "message.router.check",
      type: "HZMB",
      showSteps: true,
    },
    component: Check,
  },
  {
    path: "/taxi",
    name: "Taxi",
    meta: {
      type: "TAXI_ANNUAL",
    },
    component: Taxi,
  },
  {
    path: "/taxiPaymentResult",
    name: "taxiPaymentResult",
    meta: {
      type: "TAXI_ANNUAL",
      storage: "taxiApplication",
    },
    component: PaymentResult,
  },
  {
    path: "/paymentRecord",
    name: "PaymentRecord",
    meta: {
      type: "TAXI_ANNUAL",
    },
    component: PaymentRecord,
  },
  {
    path: "/international",
    name: "International",
    meta: {
      type: "DRV_LIC_INTER",
    },
    component: International,
  },
  {
    path: "/drivingPaymentResult",
    name: "drivingPaymentResult",
    meta: {
      type: "DRV_LIC_INTER",
      storage: "drivApplication",
    },
    component: PaymentResult,
  },
  {
    path: "/internationalPaymentRecord",
    name: "InternationalPaymentRecord",
    meta: {
      type: "DRV_LIC_INTER",
    },
    component: InternationalRecord,
  },
  {
    path: "/internationalFiles",
    name: "InternationalFiles",
    meta: {
      type: "DRV_LIC_INTER",
      search: true,
    },
    component: International,
  },
  {
    path: "/school-renew",
    name: "School",
    meta: {
      type: "SCHOOL_RENEW",
    },
    component: School,
  },
  {
    path: "/school-headmaster-renew",
    name: "HeadmasterRenew",
    meta: {
      type: "HEADMASTER_RENEW",
    },
    component: HeadmasterAndCoach,
  },
  {
    path: "/school-coach-renew",
    name: "CoachRenew",
    meta: {
      type: "COACH_RENEW",
    },
    component: HeadmasterAndCoach,
  },
  {
    path: "/school-record/:serviceType/:coachId",
    name: "SchoolRecord",
    meta: {
      type: "SCHOOL",
    },
    component: SchoolRecord,
  },
  {
    path: "/paymentResult",
    name: "PaymentResult",
    meta: {
      type: "PAYMENTRESULT",
    },
    component: PaymentResult,
  },
  {
    path: "/hzmbMoPaymentResult",
    name: "hzmbMoPaymentResult",
    meta: {
      type: "HZMBMORENEWPAYMENTRESULT",
    },
    component: HzmbMoPaymentResult,
  },
  {
    path: "/hzmb-change-vd/success/:applicationId",
    name: "hzmbChangeVdPaymentResult",
    meta: {
      type: "HZMB_CHANGE_VD",
    },
    component: () => import('@/view/DataRegistration/FormData/HzmbChangeVD/PaymentResult.vue'),
  },
  {
    path: "/booking/:serviceCode",
    name: "Booking",
    meta: {
      type: "BOOKING",
    },
    component: Booking,
  },
];

export const hzmbHFirstAppRoutes = [
  {
    path: "application",
    name: "hzmbHFirstApplication",
    meta: {
      name: "message.router.formData",
      type: "HZMB",
      serviceType: "HZMB_H_FIRST",
      showSteps: true,
    },
    component: HzmbHFirstApplication,
  },
  {
    path: "upload",
    name: "hzmbHFirstUpload",
    meta: {
      name: "message.router.upload",
      type: "HZMB",
      serviceType: "HZMB_H_FIRST",
      showSteps: true,
    },
    component: HzmbHFirstUpload,
  },
  {
    path: "check",
    name: "hzmbHFirstCheck",
    meta: {
      name: "message.router.check",
      type: "HZMB",
      serviceType: "HZMB_H_FIRST",
      showSteps: true,
    },
    component: HzmbHFirstCheck,
  },
];

export const hzmbGFirstAppRoutes = [
  {
    path: "application/:applicationId*",
    name: "hzmbGFirstApplication",
    meta: {
      name: "message.router.formData",
      type: "HZMB",
      serviceType: "HZMB_G_FIRST",
      showSteps: true,
    },
    component: HzmbGFirstApplication,
  },
  {
    path: "upload/:applicationId",
    name: "hzmbGFirstUpload",
    meta: {
      name: "message.router.upload",
      type: "HZMB",
      serviceType: "HZMB_G_FIRST",
      showSteps: true,
    },
    component: HzmbGFirstUpload,
  },
  {
    path: "check/:applicationId",
    name: "hzmbGFirstCheck",
    meta: {
      name: "message.router.check",
      type: "HZMB",
      serviceType: "HZMB_G_FIRST",
      showSteps: true,
    },
    component: HzmbGFirstCheck,
  },
];

export const hzmbChangeVDAppRoutes = [
  {
    path: "application/:applicationId?",
    name: "hzmbChangeVDApplication",
    meta: {
      name: "hzmbChange.title.formInput",
      showSteps: true,
    },
    component: () => import('@/view/DataRegistration/FormData/HzmbChangeVD/Application.vue'),
  },
  {
    path: "upload/:applicationId",
    name: "hzmbChangeVDUpload",
    meta: {
      name: "hzmbChange.title.upload",
      showSteps: true,
    },
    component: () => import('@/view/DataRegistration/FormData/HzmbChangeVD/Upload.vue'),
  },
  {
    path: "check/:applicationId",
    name: "hzmbChangeVDCheck",
    meta: {
      name: "hzmbChange.title.check",
      showSteps: true,
    },
    component: () => import('@/view/DataRegistration/FormData/HzmbChangeVD/Check.vue'),
  },
  {
    path: "payment/:applicationId",
    name: "hzmbChangeVDPayment",
    meta: {
      name: "hzmbChange.title.payment",
      showSteps: true,
    },
    component: () => import('@/view/DataRegistration/FormData/HzmbChangeVD/Payment.vue'),
  },
]

export const hzmbGInsuranceAppRoutes = [
  {
    path: "application",
    name: "hzmbGInsuranceApplication",
    meta: {
      name: "message.router.formData",
      type: "HZMB",
      serviceType: "HZMB_G_INSURANCE",
      showSteps: true,
    },
    component: () =>
      import("@/view/DataRegistration/FormData/HzmbGInsurance/Application.vue"),
  },
  {
    path: "upload",
    name: "hzmbGInsuranceUpload",
    meta: {
      name: "message.router.upload",
      type: "HZMB",
      serviceType: "HZMB_G_INSURANCE",
      showSteps: true,
    },
    component: () =>
      import("@/view/DataRegistration/FormData/HzmbGInsurance/Upload.vue"),
  },
  {
    path: "check",
    name: "hzmbGInsuranceCheck",
    meta: {
      name: "message.router.check",
      type: "HZMB",
      serviceType: "HZMB_G_INSURANCE",
      showSteps: true,
    },
    component: () =>
      import("@/view/DataRegistration/FormData/HzmbGInsurance/Check.vue"),
  },
];

const hzmbGFirstRoutes = [
  {
    path: "/hzmb-g-first",
    name: "hzmbGFirst",
    meta: {
      name: "message.router.check",
      type: "HZMB",
      serviceType: "HZMB_G_FIRST",
      showSteps: true,
    },
    component: HzmbGFirst,
    children: hzmbGFirstAppRoutes,
  },
];

export const hzmgGCancelRoutes = [
  {
    path: "/hzmb-g-cancel/application/:applicationId",
    name: "HzmbGCancelApplication",
    meta: {
      type: "HZMB",
      serviceType: "HZMB_G_CANCEL",
      showSteps: false,
    },
    component: HzmbGCancelApplication,
  },
];

const hzmbGInsuranceRoutes = [
  {
    path: "/hzmb-g-insurance",
    name: "hzmbGInsurance",
    meta: {
      name: "message.router.check",
      serviceType: "HZMB_G_INSURANCE",
      showSteps: true,
    },
    component: () =>
      import("@/view/DataRegistration/FormData/HzmbGInsurance/Index.vue"),
    children: hzmbGInsuranceAppRoutes,
  },
];

const hzmbHFirstRoutes = [
  {
    path: "/hzmb-h-first",
    name: "hzmbHFirst",
    meta: {
      type: "HZMB",
      serviceType: "HZMB_H_FIRST",
      showSteps: false,
    },
    component: HzmbHFirst,
    children: [
      ...hzmbHFirstAppRoutes,
      {
        path: "supplementUpload",
        name: "hzmbHSupplementUpload",
        meta: {
          name: "message.router.upload",
          type: "HZMB",
          serviceType: "HZMB_H_FIRST",
        },
        component: HzmbHFirstUpload,
      },
    ],
  },
];

export const hzmbHCancelRoutes = [
  {
    path: "/hzmb-H-cancel/application",
    name: "HzmbHCancelApplication",
    meta: {
      type: "HZMB",
      serviceType: "HZMB_H_CANCEL",
      showSteps: false,
    },
    component: HzmbHCancelApplication,
  },
];

export const hzmbMoRenewRoutes = [
  {
    path: "/formdata/hzmb-mo-renew/check/:businessType/:serviceType/:applicationId",
    name: "HzmbRenewCheck",
    meta: {
      name: "message.router.check",
      type: "HZMB",
      showSteps: true,
    },
    component: HzmbMoRenewCheck,
  },
  {
    path: "/formdata/hzmb-mo-renew/payment/:businessType/:serviceType/:applicationId",
    name: "HzmbMoRenewPayment",
    meta: {
      name: "message.router.payment",
      type: "HZMB",
      showSteps: true,
    },
    component: HzmbMoRenewPayment,
  },
];

export const hzmbChangeVDRoutes = [
  {
    path: "/hzmb-change-vd/:serviceType",
    name: 'hzmbChangeVD',
    meta: {
      name: "message.router.check",
      type: 'HZMB',
      showSteps: true,
    },
    component: () => import('@/view/DataRegistration/FormData/HzmbChangeVD/Index.vue'),
    children: hzmbChangeVDAppRoutes,
  }
]

const ResultTempRoutes = [
  {
    path: "/success",
    name: "Success",
    meta: {},
    component: Success,
  },
  {
    path: "/search/status",
    name: "SearchStatus",
    meta: {},
    component: SearchStatus,
  },
  {
    path: "/search/afterFiles",
    name: "AfterFiles",
    meta: {},
    component: AfterFiles,
  },
  {
    path: "/hzmb-g-first/success",
    name: "HzmbGFirstSuccess",
    meta: {
      showEn: true,
    },
    component: HzmbGFirstSuccess,
  },
  {
    path: "/hzmb-g-cancel/success",
    name: "HzmbGCancelSuccess",
    meta: {
      showEn: true,
    },
    component: HzmbGCancelSuccess,
  },
  {
    path: "/hzmb-g-insurance/success",
    name: "HzmbGInsuranceSuccess",
    meta: {
      showEn: true,
    },
    component: () =>
      import("@/view/DataRegistration/FormData/HzmbGInsurance/Success.vue"),
  },
  {
    path: "/hzmb-h-first/success",
    name: "HzmbHFirstSuccess",
    component: HzmbHFirstSuccess,
  },
];

const searchRoutes = [
  {
    path: "/search/company",
    name: "SearchCompany",
    meta: {
      title: "message.router.verify_company",
    },
    component: Company,
  },
  {
    path: "/search/personal",
    name: "SearchPersonal",
    meta: {
      title: "message.router.verify_person",
    },
    component: SearchPersonal,
  },
  {
    path: "/search/personal/phone",
    name: "SearchPhoneNum",
    meta: {
      title: "message.router.verify_person",
    },
    component: PhoneNum,
  },
];

const verifyRoutes = [
  {
    path: "/personal",
    name: "Personal",
    meta: {
      title: "message.router.verify_person",
    },
    component: Personal,
  },
  {
    path: "/personal-type/:businessType/:serviceType",
    name: "personal-type",
    meta: {
      title: "message.router.verify_person",
    },
    component: Personal,
  },
  {
    path: "/company",
    name: "Company",
    meta: {
      title: "message.router.verify_company",
    },
    component: Company,
  },
  {
    path: "/personal/onePass",
    name: "OnePass",
    meta: {
      title: "message.router.verify_person",
    },
    component: OnePass,
  },
  {
    path: "/personal/phone",
    name: "PhoneNum",
    meta: {
      title: "message.router.verify_person",
    },
    component: PhoneNum,
  },
  {
    path: "/personal-type/phone/DRV_LIC/:serviceType",
    name: "DrivingPhoneNum",
    meta: {
      title: "message.router.verify_person",
    },
    component: DrivingPhoneNum,
  },
  {
    path: "/verification/driving",
    name: "VerificationDriving",
    meta: {
      title: "message.router.verify_person",
      serviceType: "DRV_LIC_INTER",
      type: "application",
    },
    component: Driving,
  },
  {
    path: "/verification/driving/search",
    name: "DrivingSearch",
    meta: {
      title: "message.router.verify_person",
      serviceType: "DRV_LIC_INTER",
      type: "search",
    },
    component: DrivingSearch,
  },
  // 駕校
  {
    path: "/personal-type/phone/SCHOOL/:serviceType",
    name: "VerificationHeadmasterAndCoach",
    meta: {
      title: "message.router.verify_person",
    },
    component: HeadmasterAndCoachVerification,
  },
  {
    path: "/verification/hc-account/:serviceType",
    name: "HmAndCoAccount",
    meta: {
      title: "message.router.verify_person",
    },
    component: HmAndCoAccount,
  },
  {
    path: "/verification/school",
    name: "VerificationSchool",
    meta: {
      title: "message.router.verify_person",
      serviceType: "SCHOOL_RENEW",
      type: "application",
    },
    component: SchoolVerification,
  },
  // G類貨車
  {
    path: "/personal-type/phone/HZMB/HZMB_G_FIRST",
    name: "VerificationHzmbGFirst",
    meta: {
      title: "hzmbG.title.auth",
      serviceType: 'HZMB_G_FIRST'
    },
    component: HzmbGFirstVerification,
  },
  {
    path: "/personal-type/phone/HZMB/HZMB_G_CANCEL",
    name: "VerificationHzmbGCancel",
    meta: {
      title: "hzmbG.title.auth",
      serviceType: 'HZMB_G_CANCEL'
    },
    component: HzmbGCancelVerification,
  },
  {
    path: "/personal-type/phone/HZMB/HZMB_G_INSURANCE",
    name: "VerificationHzmbGInsurance",
    meta: {
      title: "hzmbG.title.auth",
      serviceType: 'HZMB_G_INSURANCE'
    },
    component: () => import("@/view/Verification/HzmbG/HzmbGInsurance.vue"),
  },
  {
    path: "/hzmb-truck-hk-apply",
    name: "VerificationHzmbGFirst",
    meta: {
      title: "hzmbG.title.auth",
      serviceType: "HZMB_G_FIRST",
    },
    component: HzmbGFirstVerification,
  },
  {
    path: "/hzmb-truck-hk-cancel",
    name: "VerificationHzmbGCancel",
    meta: {
      title: "hzmbG.title.auth",
      serviceType: "HZMB_G_CANCEL",
    },
    component: HzmbGCancelVerification,
  },
  {
    path: "/hzmb-truck-hk-insurance",
    name: "VerificationHzmbGInsurance",
    meta: {
      title: "hzmbG.title.auth",
      serviceType: "HZMB_G_INSURANCE",
    },
    component: () => import("@/view/Verification/HzmbG/HzmbGInsurance.vue"),
  },
  // H類貨車
  {
    path: "/hzmb-truck-mo-personal",
    name: "HzmbTruckMoPersonal",
    meta: {
      serviceType: "HZMB_H_FIRST_PERSON",
    },
    component: Personal
  },
  {
    path: "/hzmb-truck-mo-company",
    name: "HzmbTruckMoPersonal",
    meta: {
      serviceType: "HZMB_H_FIRST_COMP",
    },
    component: Personal
  },
  {
    path: "/verification/hzmb-h-account/:serviceType",
    name: "VerificationHzmbHFirstPersonal",
    meta: {
      serviceType: "HZMB_H_FIRST_PERSON",
    },
    component: HzmbHAccount,
  },
  {
    path: "/verification/hzmb-h/:serviceType",
    name: "VerificationHzmbHFirst2",
    meta: {
      title: "hzmbG.title.auth",
    },
    component: () => import("@/view/Verification/HzmbH/HzmbH.vue"),
  },
  // 預約
  {
    path: "/personal-type/phone/BOOKING/:serviceType",
    name: "BookingVerification",
    meta: {
      title: "message.router.verify_booking",
      type: "BOOKING",
    },
    component: BookingVerification,
  },
  {
    path: "/hzmb-truck-mo-booking",
    name: "BookingVerification",
    meta: {
      businessType: "HZMB_H_BOOKING",
      title: "message.router.verify_booking",
      type: "BOOKING",
    },
    component: BookingVerification,
  },
  // 換人換車服務
  {
    path: "/hzmb-change-vd-personal",
    name: "HzmbChangeVDPersonal",
    meta: {
      serviceType: "HZMB_CHANGE_PERSON",
      title: 'message.router.verify_person'
    },
    component: Personal
  },
  {
    path: "/hzmb-change-vd-company",
    name: "HzmbChangeVDPersonal",
    meta: {
      serviceType: "HZMB_CHANGE_COMP",
      title: 'message.router.verify_company'
    },
    component: Personal
  },
  {
    path: "/hzmb-gh-change-vd-company",
    name: "HzmbChangeVDPersonal",
    meta: {
      serviceType: "HZMB_GH_CHANGE_COMP",
      title: 'message.router.verify_company'
    },
    component: Personal
  },
  {
    path: "/verification/hzmb-change-vd-account/:serviceType",
    name: "VerificationHzmbChangeVDAccount",
    component: () => import("@/view/Verification/HzmbChangeVD/Account.vue"),
  },
  {
    path: "/verification/hzmb-change-vd/:serviceType/:loginType",
    name: "VerificationHzmbChangeVD",
    meta: {
      title: 'message.router.verify_person'
    },
    component: () => import("@/view/Verification/HzmbChangeVD/HzmbChangeVD.vue"),
  },
];

const ChildPageRoutes = [
  {
    path: "/personal",
    name: "Verification",
    meta: {},
    component: Verification,
    children: verifyRoutes,
  },
  {
    path: "/search/personal",
    name: "Search",
    meta: {},
    component: Search,
    children: searchRoutes,
  },
  {
    path: "/success",
    name: "ResultTemp",
    meta: {},
    component: ResultTemp,
    children: ResultTempRoutes,
  },
  {
    path: "/way",
    name: "Way",
    meta: {
      type: "TAXI_ANNUAL",
    },
    component: Way,
  },
];

const viewRoutes = [
  {
    path: "/",
    name: "Index",
    meta: {
      showRules: true,
    },
    component: Index,
  },
  {
    path: "/entry",
    name: "Entry",
    meta: {
      businessType: "HZMB",
      name: "message.router.entry",
      showRules: true,
      lanCode: "message.entries.home.one",
    },
    component: Entry,
  },
  {
    path: "/entryBus",
    name: "EntryBus",
    meta: {
      businessType: "BUS",
      name: "message.router.entryBus",
      showRules: true,
      lanCode: "message.entries.home.two",
    },
    component: Entry,
  },
  {
    path: "/entryTaxi",
    name: "EntryTaxi",
    meta: {
      businessType: "TAXI",
      showRules: true,
      lanCode: "message.entries.home.three",
    },
    component: Entry,
  },
  {
    path: "/entryInternational",
    name: "EntryInternational",
    meta: {
      businessType: "DRV_LIC",
      showRules: true,
      lanCode: "message.entries.home.four",
    },
    component: Entry,
  },
  {
    path: "/entrySchool",
    name: "EntrySchool",
    meta: {
      businessType: "SCHOOL",
      showRules: true,
      lanCode: "message.entries.home.five",
    },
    component: Entry,
  },
  {
    path: "/hzmb-truck",
    name: "EntryHzmbTruck",
    meta: {
      businessType: "HZMB",
      showRules: true,
      lanCode: "message.entries.home.hzmbTruck",
    },
    component: EntryHzmbTruck,
  },
  {
    path: "/hzmb-truck-hk",
    name: "EntryHzmbG",
    meta: {
      businessType: "HZMB",
      showRules: true,
      lanCode: "hzmbG.title.hzmbG",
      showEn: true,
    },
    component: Entry,
  },
  {
    path: "/hzmb-truck-mo",
    name: "EntryHzmbH",
    meta: {
      businessType: "HZMB",
      showRules: true,
      lanCode: "message.entries.home.hzmbH",
    },
    component: Entry,
  },
  {
    path: "/personal",
    name: "ChildPageTemp",
    component: ChildPageTemp,
    children: ChildPageRoutes,
  },
  {
    path: "/formData",
    name: "DataRegistration",
    component: DataRegistration,
    children: [
      ...DataRegistrationRoutes,
      ...hzmbMoRenewRoutes,
      ...hzmbGFirstRoutes,
      ...hzmgGCancelRoutes,
      ...hzmbGInsuranceRoutes,
      ...hzmbHFirstRoutes,
      ...hzmbHCancelRoutes,
      ...hzmbChangeVDRoutes,
    ],
  },
  {
    path: "/terms/:serviceType",
    name: "Terms",
    component: Terms,
  },
];

const routes = [
  {
    path: "/",
    component: Temp,
    children: viewRoutes,
  },
  {
    path: "/account",
    component: Account,
    // redirect: '/formData'
  },
  {
    path: "/entity_account",
    component: Account,
    // redirect: '/formData'
  },
  {
    path: "/account_app",
    component: Account_app,
  },
  {
    path: "/taxi_app",
    component: taxi_app,
  },
  {
    path: "/bus_app",
    component: bus_app,
  },
  {
    path: "/mpay",
    component: Mpay,
  },
  {
    path: "/face/:serviceType",
    component: Face,
  },
];

const router = new Router({
  mode: "history",
  base: process.env.VUE_APP_BASE_SERVER_PATH,
  routes: routes,
});

export default router;
